import React from "react";
import { RouteProps } from "react-router-dom";
import { ProfileFieldMapTypes } from "../../crm/profileFieldMapContextHelpers";
import {
  IValidRouteProps,
  ValidEditableFieldRoute,
} from "./ValidEditableFieldRoute";

export interface ISharedRouteProps extends RouteProps {
  type: ProfileFieldMapTypes;
  routes: Omit<IValidRouteProps, "type">[];
}

export const SharedEditableFieldRoute = (props: ISharedRouteProps) => {
  const { type, routes, ...routerProps } = props;
  const supportedRoute = routes.find((route) => !!route.fieldMap);
  if (!supportedRoute) {
    throw new Error(
      `Could not find valid field map while accessing shared route ${routerProps.path} for type ${type}`
    );
  }
  return (
    <ValidEditableFieldRoute
      {...routerProps}
      type={type}
      fieldMap={supportedRoute.fieldMap}
      screen={supportedRoute.screen}
    />
  );
};
